import { ValidationProps } from 'ui';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { CodeListItem, ModifiedImportMappings, CodetableMetadata } from './types-store';
import { FilterSearchModel } from 'app/area/search-filters/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const ACTION = {
  REQUEST_CODE_ITEMS: 'IMPORT_MAPPINGS:REQUEST_CODE_ITEMS',
  RECEIVE_CODE_ITEMS: 'IMPORT_MAPPINGS:RECEIVE_CODE_ITEMS',
  FAIL_CODE_ITEMS: 'IMPORT_MAPPINGS:FAIL_CODE_ITEMS',
  EXPAND_CODE_ITEM: 'IMPORT_MAPPINGS:EXPAND_CODE_ITEM',
  UPDATE_CODE_LIST_BRANCH: 'IMPORT_MAPPINGS:UPDATE_CODE_LIST_BRANCH',
  UPDATE_SEARCH_MODEL: 'IMPORT_MAPPINGS:UPDATE_SEARCH_MODEL',
  REQUEST_IMPORTSET_DATA: 'IMPORT_MAPPINGS_HIERARCHY:REQUEST_IMPORTSET_DATA',
  RECEIVE_IMPORTSET_DATA: 'IMPORT_MAPPINGS_HIERARCHY:RECEIVE_IMPORTSET_DATA',
  FAIL_IMPORTSET_DATA: 'IMPORT_MAPPINGS_HIERARCHY:FAIL_IMPORTSET_DATA',
  REQUEST_CODETABLE_DATA: 'IMPORT_MAPPINGS_HIERARCHY:REQUEST_CODETABLE_DATA',
  RECEIVE_CODETABLE_DATA: 'IMPORT_MAPPINGS_HIERARCHY:RECEIVE_CODETABLE_DATA',
  FAIL_CODETABLE_DATA: 'IMPORT_MAPPINGS_HIERARCHY:FAIL_CODETABLE_DATA',
  REQUEST_CODETABLE_METADATA: 'IMPORT_MAPPINGS_HIERARCHY:REQUEST_CODETABLE_METADATA',
  RECEIVE_CODETABLE_METADATA: 'IMPORT_MAPPINGS_HIERARCHY:RECEIVE_CODETABLE_METADATA',
  FAIL_CODETABLE_METADATA: 'IMPORT_MAPPINGS_HIERARCHY:FAIL_CODETABLE_METADATA',
  REQUEST_CATEGORY_OPTIONS: 'IMPORT_MAPPINGS_HIERARCHY:REQUEST_CATEGORY_OPTIONS',
  RECEIVE_CATEGORY_OPTIONS: 'IMPORT_MAPPINGS_HIERARCHY:RECEIVE_CATEGORY_OPTIONS',
  FAIL_CATEGORY_OPTIONS: 'IMPORT_MAPPINGS_HIERARCHY:FAIL_CATEGORY_OPTIONS',
  SET_CURRENT_CODE: 'IMPORT_MAPPINGS_HIERARCHY:SET_CURRENT_CODE',
  CLEAR_CURRENT_CODE: 'IMPORT_MAPPINGS_HIERARCHY:CLEAR_CURRENT_CODE',
  MODIFY_ITEM: 'IMPORT_MAPPINGS_HIERARCHY:MODIFY_ITEM',
  REQUEST_SAVE_ITEM_CHANGES: 'IMPORT_MAPPINGS_HIERARCHY:REQUEST_SAVE_ITEM_CHANGES',
  RECEIVE_SAVE_ITEM_CHANGES: 'IMPORT_MAPPINGS_HIERARCHY:RECEIVE_SAVE_ITEM_CHANGES',
  FAIL_SAVE_ITEM_CHANGES: 'IMPORT_MAPPINGS_HIERARCHY:FAIL_SAVE_ITEM_CHANGES',
  VALIDATION_CHANGE: 'IMPORT_MAPPINGS_HIERARCHY:VALIDATION_CHANGE',
  UPDATE_CODETABLE: 'IMPORT_MAPPINGS_HIERARCHY:UPDATE_CODETABLE',
  UPDATE_CATEGORY: 'IMPORT_MAPPINGS_HIERARCHY:UPDATE_CATEGORY',
  UPDATE_IMPORT_SET: 'IMPORT_MAPPINGS_HIERARCHY:UPDATE_ACTIVE_VALUE',
  CLEAR_ALL: 'IMPORT_MAPPINGS_HIERARCHY:CLEAR_ALL',
  CLEAR_METADATA: 'IMPORT_MAPPINGS_HIERARCHY:CLEAR_METADATA',
  CLEAR_LIST: 'IMPORT_MAPPINGS_HIERARCHY:CLEAR_LIST',
  CLEAR_VALIDATION: 'IMPORT_MAPPINGS_HIERARCHY:CLEAR_VALIDATION'
};

export class RequestCodeItems {
  public type: string = ACTION.REQUEST_CODE_ITEMS;
  constructor(public codetableId: number, public parentId: number, public categoryId: number, public searchModel: FilterSearchModel) {
  }
}

export class ReceiveCodeItems {
  public type: string = ACTION.RECEIVE_CODE_ITEMS;
  constructor(public codetableId: number, public parentId: number, public categoryId: number, public searchModel: FilterSearchModel,
    public codeItems: CodeListItem[], public numberOfResults: number, public clearList?: boolean) {
  }
}

export class FailCodeItems {
  public type: string = ACTION.FAIL_CODE_ITEMS;
  constructor(public codetableId: number, public parentId: number, public categoryId: number, public searchModel: FilterSearchModel) {
  }
}

export class ExpandCodeItem {
  public type: string = ACTION.EXPAND_CODE_ITEM;
  constructor(public parentId: number) {
  }
}

export class UpdateCodeListBranch {
  public type: string = ACTION.UPDATE_CODE_LIST_BRANCH;
}

export class UpdateSearchModel {
  public type: string = ACTION.UPDATE_SEARCH_MODEL;
  constructor(public model: FilterSearchModel) {
  }
}

export class RequestImportSetData {
  public type: string = ACTION.REQUEST_IMPORTSET_DATA;
}

export class ReceiveImportSetData {
  public type: string = ACTION.RECEIVE_IMPORTSET_DATA;
  constructor(public data: ComplexValue<number>) { }
}

export class FailImportSetData {
  public type: string = ACTION.FAIL_IMPORTSET_DATA;
}

export class RequestCodetableData {
  public type: string = ACTION.REQUEST_CODETABLE_DATA;
}

export class ReceiveCodetableData {
  public type: string = ACTION.RECEIVE_CODETABLE_DATA;
  constructor(public data: ComplexValue<number>) { }
}

export class FailCodetableData {
  public type: string = ACTION.FAIL_CODETABLE_DATA;
}

export class RequestCodetableMetadata {
  public type: string = ACTION.REQUEST_CODETABLE_METADATA;
}

export class ReceiveCodetableMetadata {
  public type: string = ACTION.RECEIVE_CODETABLE_METADATA;
  constructor(public metadata: CodetableMetadata) { }
}

export class FailCodetableMetadata {
  public type: string = ACTION.FAIL_CODETABLE_METADATA;
}

export class RequestCategoryOptions {
  public type: string = ACTION.REQUEST_CATEGORY_OPTIONS;
  constructor(public id: string, public loadOptionsParams: LoadOptions) {
  }
}

export class ReceiveCategoryOptions {
  public type: string = ACTION.RECEIVE_CATEGORY_OPTIONS;

  constructor(
    public id: string,
    public loadOptionsParams: LoadOptions,
    public codes: CodeComplexValue<number>[],
    public currentOptions: CodeComplexValue<number>[]) {
  }
}

export class FailCategoryOptions {
  public type: string = ACTION.FAIL_CATEGORY_OPTIONS;

  constructor(public id: string, public loadOptionsParams: LoadOptions) {
  }
}

export class SetCurrentCode {
  public type: string = ACTION.SET_CURRENT_CODE;
  constructor(public data: CodeListItem) { }
}

export class ClearCurrentCode {
  public type: string = ACTION.CLEAR_CURRENT_CODE;
}

export class ModifyItem {
  public type: string = ACTION.MODIFY_ITEM;
  constructor(public modifiedData: ModifiedImportMappings) { }
}

export class RequestSaveItemChanges {
  public type: string = ACTION.REQUEST_SAVE_ITEM_CHANGES;
}

export class ReceiveSaveItemChanges {
  public type: string = ACTION.RECEIVE_SAVE_ITEM_CHANGES;
  constructor(public importNumber: number) { }
}

export class FailSaveItemChanges {
  public type: string = ACTION.FAIL_SAVE_ITEM_CHANGES;
}

export class ValidationChange {
  public type: string = ACTION.VALIDATION_CHANGE;

  constructor(public validation: { [key: string]: ValidationProps }) { }
}

export class UpdateCodetable {
  public type: string = ACTION.UPDATE_CODETABLE;
  constructor(public value: ComplexValue<number>) { }
}

export class UpdateCategory {
  public type: string = ACTION.UPDATE_CATEGORY;
  constructor(public value: ComplexValue<number>) {
  }
}

export class UpdateImportSet {
  public type: string = ACTION.UPDATE_IMPORT_SET;
  constructor(public value: ComplexValue<number>) { }
}

export class ClearAll {
  public type: string = ACTION.CLEAR_ALL;
}

export class ClearMetadata {
  public type: string = ACTION.CLEAR_METADATA;
  constructor(public name: string) {
  }
}

export class ClearList {
  public type: string = ACTION.CLEAR_LIST;
}

export class ClearValidation {
  public type: string = ACTION.CLEAR_VALIDATION;
}
